<template>
  <div class="app-step-two-tabs-prepay">
    <div class="app-step-two-tabs__wrapper">
      <div class="app-step-two-tabs-upload__body">
        <div v-if="isSpecialPackage">
          <loading-bar v-if="isLoading"></loading-bar>

          <ul class="prepay-list" v-else>
            <li class="prepay-list-item">
              <h6>{{ specialPackageName }}</h6>

              <ul class="prepay-list-price">
                <li
                  v-for="packageItemPrice in specialPackages"
                  :key="packageItemPrice.id"
                  class="prepay-list-price-item"
                >
                  <input
                    :id="`package-${packageItemPrice.id}`"
                    v-model="packagePriceId"
                    name="package-price-plan"
                    type="radio"
                    :value="packageItemPrice.id"
                  />
                  <label :for="`package-${packageItemPrice.id}`">
                    Order {{ packageItemPrice.credits }}
                    {{ specialPackageName }}(s) for
                    {{ currency(packageItemPrice.price).format() }}
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div v-else>
          <loading-bar v-if="isLoading"></loading-bar>

          <ul class="prepay-list" v-else>
            <li
              class="prepay-list-item"
              v-for="packageItem in packages"
              :key="packageItem.id"
            >
              <h6>{{ packageItem.name }}</h6>
              <ul class="prepay-list-subitems">
                <li
                  class="prepay-list-subitem"
                  v-for="packageItemDescription in packageItem.description"
                  :key="packageItemDescription"
                >
                  <list-arrow></list-arrow>
                  <span> {{ packageItemDescription }}</span>
                </li>
              </ul>

              <div
                v-if="packageItem?.creditExpirationMonths"
                class="prepay-list-expiration"
              >
                <span
                  >These credits are good for
                  {{ packageItem.creditExpirationMonths }} months</span
                >
              </div>

              <ul class="prepay-list-price">
                <li
                  v-for="packageItemPrice in packageItem.packagePrices"
                  :key="packageItemPrice.id"
                  class="prepay-list-price-item"
                >
                  <input
                    :id="`package-${packageItemPrice.id}`"
                    v-model="packagePriceId"
                    name="package-price-plan"
                    type="radio"
                    :value="packageItemPrice.id"
                  />
                  <label :for="`package-${packageItemPrice.id}`">
                    Order {{ packageItemPrice.credits }}
                    {{ packageItem.name }} for
                    {{ currency(packageItemPrice.price).format() }}
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <navigation-buttons
      :disabled-outer-condition="!packagePriceId || isOrderLoading"
      :loading="isOrderLoading"
      @onPreviousButtonClick="handlePreviousClick"
      @onNextButtonClick="handleNextClick"
    ></navigation-buttons>
  </div>
</template>

<script setup>
import { onMounted, watch, computed } from 'vue'
import { usePackages } from '@core/composables/usePackages'
import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'
import { useOrder } from '@core/composables/order/useOrder'
import { packagePriceId } from './state'
import { useTabsStore } from '@/stores/tabs'
import { storeToRefs } from 'pinia'
import {
  IS_MAIN_STORAGE_KEY,
  SPECIAL_PACKAGE_STORAGE_KEY,
} from '@modules/app-steps/step-one/useSpecialPackage'

import NavigationButtons from '@modules/app-steps/step-two/navigation-buttons/index.vue'
import currency from 'currency.js'
import ListArrow from '@/assets/svg/list-arrow.svg?component'
import LoadingBar from '@modules/ui/loading-bar.vue'

const { useUpdateOrder } = useOrder()
const { isLoading: isOrderLoading, updateOrder } = useUpdateOrder()
const { navigate } = useNavigationButtons()
const { getFrontendTabBuilder } = storeToRefs(useTabsStore())

const { packages, isLoading } = usePackages()

const isSpecialPackage = computed(
  () => localStorage.getItem(IS_MAIN_STORAGE_KEY) === 'no'
)
const specialPackage = computed(() =>
  JSON.parse(localStorage.getItem(SPECIAL_PACKAGE_STORAGE_KEY))
)

const specialPackageName = computed(() => specialPackage.value?.name)
const specialPackages = computed(() => specialPackage.value?.packagePrices)
const firstPackageId = computed(() => specialPackages.value[0]?.id)

const handlePreviousClick = () =>
  updateOrder({ ...getFrontendTabBuilder.value() }, () => navigate())

const handleNextClick = () => {
  updateOrder({ ...getFrontendTabBuilder.value(true) })
}

watch(packagePriceId, (selectedPackagePriceId) => {
  updateOrder({ packagePriceId: selectedPackagePriceId })
})

onMounted(() => {
  if (specialPackage.value) {
    packagePriceId.value = firstPackageId.value
  }
})
</script>
